module.exports = "<div class=\"app-body\">\n\n    <ui-view name=\"content\">\n        \n    </ui-view>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./Client/app/tasks/controllers/nolinktask/nolinktask.html
// module id = 612
// module chunks = 0